// extracted by mini-css-extract-plugin
export default {"root":"Destination__root--JHhqP","avatar":"Destination__avatar--qUUmJ","avatarAttaches":"Destination__avatarAttaches--2Z_ng","mailIcon":"Destination__mailIcon--3z966"};